(() => {
  if (window.SMNDeliveryAnalytics) return;
  const enabled = document.currentScript?.dataset.smnAnalyticsEnabled !== 'false';
  const counters = {sent: 0, withheld: 0};
  let pendingSearch = null;
  const consent = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return typeof privacy?.analyticsProcessingAllowed === 'function'
        && privacy.analyticsProcessingAllowed() === true;
    } catch { return false; }
  };
  const context = choice => ({
    delivery_mode: '',
    ui_surface: choice?.classList.contains('smn-delivery-choice--mini-cart') ? 'mini_cart' : 'cart',
    smn_test_mode: choice?.dataset.testMode === 'true' ? 'test' : 'live',
    branch_id: '', branch_name: '', search_result: '', branches_shown: 0,
    input_valid: '', tracking_version: '2'
  });
  const emit = (name, choice, fields) => {
    try {
      if (!enabled || !choice?.isConnected || !consent()) { counters.withheld++; return; }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({event: name, ...context(choice), ...fields});
      counters.sent++;
    } catch { counters.withheld++; }
  };
  const branchFields = choice => {
    const id = choice.querySelector('[data-smn-pref-field="smn_pickup_pref_id"]')?.value || '';
    const name = choice.querySelector('[data-smn-pref-field="smn_pickup_pref_name"]')?.value || '';
    return /^\d{1,20}$/.test(id)
      ? {branch_id: id, branch_name: name.replace(/\s+/g, ' ').trim().slice(0, 100)}
      : {branch_id: '', branch_name: ''};
  };
  window.SMNDeliveryAnalytics = Object.freeze({
    version: '2',
    status: () => ({enabled, analytics_allowed: consent(), tracking_version: '2', ...counters}),
    checkout(choice, mode) {
      try {
        if (!['domicilio', 'pickup'].includes(mode)) return;
        pendingSearch = null;
        emit('smn_checkout_continue', choice, {
          delivery_mode: mode, ...(mode === 'pickup' ? branchFields(choice) : {})
        });
      } catch {}
    }
  });
  if (!enabled) return;
  const panelOf = target => target?.closest('.smn-pickup');
  const choiceOf = target => target?.closest('smn-delivery-choice');
  const idlePanel = panel => panel && !panel.hidden && panel.isConnected
    && panel.querySelector('.smn-pickup__body')?.getAttribute('aria-busy') !== 'true';
  const beginSearch = panel => {
    if (!idlePanel(panel)) return;
    const choice = choiceOf(panel);
    if (!choice || choice.getAttribute('aria-busy') === 'true') return;
    const input = panel.querySelector('#smn-pickup-postal');
    const valid = /^[0-9]{5}$/.test(input?.value.trim() || '');
    pendingSearch = valid ? {panel, choice, permitted: consent(), started: false} : null;
    emit('smn_pickup_search', choice, {delivery_mode: 'pickup', input_valid: String(valid)});
  };
  const finishSearch = (records) => {
    if (!pendingSearch) return;
    const {panel, choice, permitted} = pendingSearch;
    if (!panel.isConnected || panel.hidden || !choice.isConnected) { pendingSearch = null; return; }
    const body = panel.querySelector('.smn-pickup__body');
    if (body?.getAttribute('aria-busy') === 'true'
        || records.some(record => record.target === body && record.attributeName === 'aria-busy' && record.oldValue === 'true')) {
      pendingSearch.started = true;
    }
    if (!pendingSearch.started || !idlePanel(panel)) return;
    const status = panel.querySelector('.smn-pickup__status');
    if (!status?.textContent.trim()) return;
    const branches = panel.querySelectorAll('input[name="smn-pickup-branch"]').length;
    const error = status.classList.contains('smn-pickup__error');
    let noStores = '';
    try {
      noStores = JSON.parse(document.getElementById('smn-delivery-cart-data')?.dataset.finderTexts || '{}').no_stores || '';
    } catch {}
    const normalized = value => String(value).replace(/\s+/g, ' ').trim();
    if (!error && !branches && (!noStores || normalized(status.textContent) !== normalized(noStores))) return;
    const result = error ? 'error' : branches ? 'available' : 'unavailable';
    pendingSearch = null;
    if (permitted) emit('smn_pickup_results', choice, {
      delivery_mode: 'pickup', search_result: result,
      branches_shown: result === 'available' ? branches : 0
    });
  };
  window.addEventListener('click', event => {
    try {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('button');
      if (!button || button.disabled || button.matches(':disabled')) return;
      const choice = choiceOf(button);
      const mode = button.dataset.smnDeliveryMode;
      if (choice && ['domicilio', 'pickup'].includes(mode)
          && choice.getAttribute('aria-busy') !== 'true') {
        pendingSearch = null;
        emit('smn_delivery_selected', choice, {delivery_mode: mode});
      }
      if (button.matches('.smn-pickup__close, .smn-pickup__back, [data-smn-clear-test]')) pendingSearch = null;
      if (button.matches('.smn-pickup__search')) beginSearch(panelOf(button));
    } catch {}
  }, {capture: true, passive: true});
  window.addEventListener('keydown', event => {
    try {
      if (!(event.target instanceof Element)) return;
      if (event.key === 'Escape') pendingSearch = null;
      if (event.key === 'Enter' && !event.repeat && !event.isComposing
          && event.target.matches('#smn-pickup-postal')) beginSearch(panelOf(event.target));
    } catch {}
  }, {capture: true, passive: true});
  window.addEventListener('input', event => {
    if (event.target instanceof Element && event.target.matches('#smn-pickup-postal')) pendingSearch = null;
  }, {capture: true, passive: true});
  window.addEventListener('change', event => {
    try {
      if (!(event.target instanceof Element)) return;
      const radio = event.target;
      if (!radio.matches('input[name="smn-pickup-branch"]') || !radio.checked || radio.disabled) return;
      const panel = panelOf(radio), choice = choiceOf(radio);
      if (!choice || !idlePanel(panel) || !/^\d{1,20}$/.test(radio.value)) return;
      emit('smn_pickup_branch_selected', choice, {
        delivery_mode: 'pickup', branch_id: radio.value,
        branch_name: (radio.closest('.smn-pickup__branch')?.querySelector('h3')?.textContent || '')
          .replace(/\s+/g, ' ').trim().slice(0, 100)
      });
    } catch {}
  }, {capture: true, passive: true});
  new MutationObserver(records => {
    try { finishSearch(records); } catch { pendingSearch = null; }
  }).observe(document.documentElement, {
    childList: true, subtree: true, characterData: true,
    attributes: true, attributeOldValue: true, attributeFilter: ['aria-busy', 'hidden', 'class']
  });
  window.addEventListener('pageshow', () => { pendingSearch = null; });
  const loadPrivacy = () => {
    try {
      if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], () => {});
      }
    } catch {}
  };
  loadPrivacy();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadPrivacy, {once: true});
})();
